import { REDIRECT_MOBILE } from './redirectMobileAction'

const redirectMobileInit = false
export const redirectMobile = (state = redirectMobileInit, action) => {
	switch (action.type) {
		case REDIRECT_MOBILE:
			return true
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redirectmobile/redirectMobileReducer.js